import { Session } from "../index.js";
import { log, generatePlayerID, settings } from "@tumbodash/browserPackages";
import { io } from "socket.io-client";
import store from "../store.js";
import Game from "../game/index.js";
import { prefetch } from "@tumbodash/gameShelf/client";
import "./syncListener.js";

// Initialization object
async function initSocketIo() {
	log.sessionFx("(client/socket/init)");
	var playerId = localStorage.getItem("playerId");
	if (playerId === null) {
		localStorage.setItem("playerId", generatePlayerID());
		playerId = localStorage.getItem("playerId");
	}
	log.sessionSocket(`Connecting game engine at: ${settings.serverUrl}session`);

	const socket = io((settings.serverUrl as string) + "session", {
		auth: { playerId },
		transports: ["websocket"],
	});

	store.socket = socket;
	store.playerId = playerId;

	socket.off("connect");
	socket.on("connect", () => {
		log.sessionSocket("Game Engine Socket Connected, Socket ID: ", socket.id);
	});

	socket.off("connect_error");
	socket.on("connect_error", (error: Error) => {
		log.sessionSocket("Game Engine Socket Connection Error", error);
	});

	socket.off("disconnect");
	socket.on("disconnect", (reason: string) => {
		log.sessionSocket("Game Engine Socket Disconnected", reason);
	});

	socket.onAny((eventName: string) => {
		log.sessionEvent("[%s]", eventName);
	});

	socket.off("game:launch");
	socket.on("game:launch", (payload: { data: { id: string } }) => {
		log.session("Game launch received: ", payload);
		Game.launch(payload.data.id);
	});

	socket.off("game:end");
	socket.on("game:end", (payload: { data: { sessionId: string } }) => {
		log.session("Game end received: ", payload);
		Game.end(payload.data.sessionId);
	});

	socket.off("sync");
	socket.on("sync", (payload: { data: { id: string; [key: string]: unknown } }) => {
		log.session("Session sync received: ", payload);
		var sessionId: string;
		if (!Session.has(payload.data.id)) {
			sessionId = Session.create({ sessionId: payload.data.id });
		} else {
			sessionId = payload.data.id;
		}
		Session.update(sessionId, payload.data);
		if (payload.data.slug) prefetch(payload.data.slug as string);
		// Snapshot-driven launch: if the server says this session is live, the
		// lifecycle machine launches it (idempotent; ignored if not acquired
		// locally). game:launch above is just a redundant nudge — ordering
		// between sync and game:launch no longer matters.
		Game.onSnapshot(sessionId, payload.data);
	});

	return null;
}

export default initSocketIo;
